import { useState, useEffect } from 'react'
import { toast } from '@wiggui/ds/Toast'
import {
  IFindBroker,
  getFindBrokersByName,
  putReassignAdviser
} from '../../../services'
import { useModalReassignAdviserStore } from '../../../store'
import { useDebounce } from '../../../hooks/ds/useDebounce'

export const useReassignAdviser = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [adviserSelected, setAdviserSelected] = useState<
    IFindBroker | undefined
  >(undefined)

  const [nameAdviser, setNameAdviser] = useState('')
  const [resultSearch, setResultSearch] = useState<IFindBroker[]>([])

  const debounceNameAdviser = useDebounce(nameAdviser, 750)

  const modalReassignAdviser = useModalReassignAdviserStore(
    (state) => state?.modalReassignAdviser
  )
  const reset = useModalReassignAdviserStore((state) => state?.reset)

  const onSuccess = modalReassignAdviser?.onSuccess

  const onClose = () => {
    setIsLoading(false)
    setAdviserSelected(undefined)
    setNameAdviser('')
    reset()
  }

  const filteredOptions = resultSearch?.filter((option) => {
    if (!nameAdviser) {
      return []
    }
    return option?.fullname
      ?.toLowerCase()
      ?.includes(debounceNameAdviser?.toLowerCase())
  })

  const fetchBrokersByName = async (name: string) => {
    setIsLoading(true)
    try {
      const res = await getFindBrokersByName({ name })
      if (res.isSuccess && res.data) {
        setResultSearch(res?.data)
      } else {
        toast({
          type: 'error',
          title: 'Error al obtener los asesores'
        })
      }
    } catch (error) {
      toast({
        type: 'error',
        title: 'Error al obtener los asesores'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchReassignedAdviser = async ({
    userId,
    ids
  }: {
    userId: string | number
    ids: string[]
  }) => {
    setIsLoading(true)
    try {
      const { isSuccess } = await putReassignAdviser({
        advisorId: userId,
        propertyIds: ids
      })
      if (isSuccess) {
        toast({
          type: 'success',
          title: 'El asesor se asignó con éxito'
        })
        onClose()
        onSuccess?.()
      } else {
        toast({
          type: 'error',
          title: 'No se asignó al asesor'
        })
      }
    } catch (error) {
      toast({
        type: 'error',
        title: 'No se asignó al asesor'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleChangeAdvisor = async (broker: IFindBroker) => {
    if (broker?.fullname === adviserSelected?.fullname) {
      setAdviserSelected(undefined)
      return
    }

    setAdviserSelected(broker)
  }

  const handleAssignedAdvisor = () => {
    if (!adviserSelected) {
      return
    }

    fetchReassignedAdviser({
      userId: adviserSelected?.userId,
      ids: modalReassignAdviser?.properties?.map(
        (property) => property?.propertyId
      )
    })
  }

  useEffect(() => {
    if (debounceNameAdviser?.length >= 0) {
      fetchBrokersByName(debounceNameAdviser)
    }
  }, [debounceNameAdviser])

  return {
    handleAssignedAdvisor,
    isLoading,
    adviserSelected,
    nameAdviser,
    debounceNameAdviser,
    setNameAdviser,
    filteredOptions,
    handleChangeAdvisor,
    modalReassignAdviser,
    onClose
  }
}
